import { apiRevGeocodeLocationGoogle } from './API/TrxNowAPI';

export async function getCurrentLocation() {
  var temp = ""
  console.log(temp) 
  await navigator.geolocation.getCurrentPosition(
    (position) => {
    //console.log(position)
    temp = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    }
  },
  (error)=>{
    console.log(error)
  }
  );
  //console.log(temp)
};

export const localStorer = (data) => {
    const dataTime = {
        date: new Date(),
        dataStr: data
    }
    const dataStr = JSON.stringify(dataTime)
    localStorage.setItem('TrxNowForm', dataStr)    
}

export const clearLocalStorage = () => {
  localStorage.removeItem('TrxNowForm');
}

export const localStorageGetter = () => {
    const retrievedItem = localStorage.getItem('TrxNowForm');
    var parsedItem = JSON.parse(retrievedItem);
    //console.log(parsedItem)
    if(retrievedItem === null)
    {
        return null;
    }
    else{
        return parsedItem.dataStr
    }
    //console.log()
}

export const asyncRevGeocodeLocationGoogle = (coords) => {
  return new Promise( (resolve, reject) => {
    try{
      apiRevGeocodeLocationGoogle(
        { lat: coords.latitude, lng: coords.longitude },
        (addressResult) => {
          console.log("Address Result:", addressResult);
      
          resolve({
            coords: {
              lat: coords.latitude,
              lng: coords.longitude,
            },
            address: addressResult,
          });
        }
      );
    }catch(e){
      console.error(e);
      reject();
    }
  });
}